<template>
  <div>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          연장근무 신청일
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{ mapPeriod }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >출근시간</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{ mapSHm }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >퇴근시간</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{ mapEHm }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >연장근무시간</v-list-item-subtitle
        >
        <!--휴일연장(0075 값 있을 때)-->
        <v-list-item-title class="app-desc"
          ><strong>{{ GET_APP_MAP_DATA.requestHour }}</strong
          >시간 ( 휴게 : <strong>{{ GET_APP_MAP_DATA.restHour }}</strong
          >시간 제외 )
        </v-list-item-title>
        <!--휴일연장없을때 (기존)-->
        <v-list-item-title
          class="app-desc"
          v-if="GET_APP_MAP_DATA.holOtHour > 0"
        >
          ( 휴일기본 <strong>{{ GET_APP_MAP_DATA.hour }} </strong>시간 +
          휴일연장 :<strong>{{ GET_APP_MAP_DATA.holOtHour }}</strong>
          시간 )
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      two-line
      flat
      class="px-5"
      v-if="
        GET_APP_MAP_DATA.otInfoDirectYn === 'Y' ||
        (GET_APP_MAP_DATA.otInfoDirectYn === 'N' &&
          GET_APP_MAP_DATA.directRequestHour !== null)
      "
    >
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          직접입력 연장근무시간
        </v-list-item-subtitle>
        <!--휴일연장(0075 값 있을 때)-->
        <v-list-item-title class="app-desc">
          <strong>{{
            GET_APP_MAP_DATA.directRequestHour !== null
              ? GET_APP_MAP_DATA.directRequestHour
              : GET_APP_MAP_DATA.requestHour
          }}</strong>
          시간 ( 휴게 :
          <strong>{{
            GET_APP_MAP_DATA.directRestHour !== null
              ? GET_APP_MAP_DATA.directRestHour
              : GET_APP_MAP_DATA.restHour
          }}</strong>
          시간 제외 )
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5" v-if="isAlterAppl">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >대체휴가 신청일</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{ alterYmd }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5" v-if="isAlterAppl">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >대체휴가 종류</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{
          GET_GNT_CD_NM
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          출퇴근변경신청 여부
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{
          GET_APP_MAP_DATA.inoutYn === 'Y' ? '신청함' : '신청 안 함'
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">비고</v-list-item-subtitle>
        <v-list-item-content class="app-desc">{{
          GET_MAP_REASON
        }}</v-list-item-content>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import viewerMixin from '@/mixins/viewerMixin.js';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  mixins: [viewerMixin],
  data: () => ({}),
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('CODE', ['GET_GNT_CD_NM']),
    // 기간
    mapPeriod() {
      return dayjs(this.GET_APP_MAP_DATA.ymd).format('YYYY-MM-DD');
    },
    alterYmd() {
      return dayjs(this.GET_APP_MAP_DATA.alterYmd).format('YYYY-MM-DD');
    },
    mapSHm() {
      const sHm = this.GET_APP_MAP_DATA.reqSHm;
      if (sHm === undefined || sHm === null) return '-';
      return `${sHm.substr(0, 2)}:${sHm.substr(2, 2)}`;
    },
    mapEHm() {
      const eHm = this.GET_APP_MAP_DATA.reqEHm;
      if (eHm === undefined || eHm === null) return '-';
      return `${eHm.substr(0, 2)}:${eHm.substr(2, 2)}`;
    },
    // 보상이 대체휴가 인지
    isAlterAppl() {
      return this.GET_APP_MAP_DATA.reqTimeCd === 'B';
    },
  },
  props: {
    appInfoParam: Object,
  },
  methods: {
    // 신청 상세 내용 조회
    async fetchApplicationMap() {
      this.ON_APP_SPINNER(); // 스피너 ON
      await this.$store.dispatch('ELA/FETCH_OT_WORK_MAP', {
        searchApplSeq: this.appInfoParam.applSeq,
        searchApplSabun: this.appInfoParam.applSabun,
      });

      if (this.isAlterAppl) {
        await this.$store.dispatch('CODE/FETCH_GNT_CD', {
          cmd: 'alterGntCdApp',
        });

        this.SET_GNT_CODE_TMP(this.GET_APP_MAP_DATA.alterGntCd);
      }
      this.OFF_APP_SPINNER(); // 스피너 OFF
    },
  },
  mounted() {
    // console.log('OtWorkViewerData mounted');
    this.fetchApplicationMap();
  },
};
</script>

<style></style>
